'use client';

import { createTheme, Shadows } from '@mui/material/styles';

import { palette } from './palette';
import { typography } from './typography';

const borderRadius = 4;

const theme = createTheme({
  palette: {
    ...palette,
    text: {
      primary: palette.text?.primary,
    },
  },
  shadows: Array(25).fill('none') as Shadows,
  typography: {
    fontFamily: 'Lato, Arial, sans-serif',
    ...typography,
  },
  shape: {
    borderRadius: borderRadius,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
      xxl: 1920,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: borderRadius,
        },
      },
    },
    MuiContainer: {
      defaultProps: {
        maxWidth: 'xxl',
      },
      styleOverrides: {
        root: {
          paddingLeft: '48px !important',
          paddingRight: '48px !important',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          ...typography,
        },
      },
    },
  },
});

export default theme;
